@let hasScenarioOptions = scenariosFeature.selectors.hasScenarios.asSignal();
@let currentScenarioNameText =
  scenariosFeature.selectors.currentScenarioName.asSignal();
@let shouldPresentOverlay =
  scenariosFeature.selectors.shouldPresentOverlay.asSignal();
@let canCreateScenario =
  meFeature.contexts.selectors.currentUserCanCreateScenario.asSignal();

<div class="atn-scenario-dropdown">
  @if (hasScenarioOptions) {
    <div
      class="atn-scenario-dropdown__control"
      (click)="appHeaderScenarioClickedHandler()"
      #dropdownOverlayTrigger
    >
      <div
        class="atn-scenario-dropdown__control-name"
        data-test-id="dropdownScenarioButton"
      >
        {{ currentScenarioNameText }}
      </div>
      <div class="atn-scenario-dropdown__control-arrow">
        <i class="atn-icon atn-triangle-down atn-dark"></i>
      </div>
    </div>
    @if (shouldPresentOverlay) {
      <atn-ds-attached-overlay
        [origin]="dropdownOverlayTrigger"
        [offsetX]="-320"
        [offsetY]="10"
        (backdropClick)="scenarioOverlayBackdropClickedHandler()"
      >
        <atn-scenario-dropdown-overlay />
      </atn-ds-attached-overlay>
    }
  } @else if (canCreateScenario) {
    <atn-ds-button (click)="addBtnClickedHandler()">
      Create First Scenario
    </atn-ds-button>
  }
</div>

<atn-scenario-edit-dialog />
<atn-scenario-delete-dialog />
